import { Component, Input } from '@angular/core';
import { supportWspLink } from '@shared/constants/support';

@Component({
  selector: 'app-suport-button',
  standalone: true,
  imports: [],
  templateUrl: './suport-button.component.html',
  styleUrl: './suport-button.component.scss'
})
export class SuportButtonComponent {
@Input() text:string="Quiero saber más sobre AdminAI";
//el número de soporte vive en shared/constants/support.ts (lo usa también el aviso de WhatsApp desconectado)
get link(): string {
  return supportWspLink(this.text);
}
}
